module.exports = "fragment UserHistory on UserType{id rowId username firstName lastName}"